/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { RecoilRoot } from 'recoil'

import App from './App'
import * as serviceWorker from './serviceWorker'
import './tailwind.css'

// recoil 0.2's RecoilRoot is typed React.FC<RecoilRootProps> with no `children`;
// React 19 dropped implicit FC children, so widen the type (no runtime effect).
const RecoilRootWithChildren = RecoilRoot as React.FC<React.PropsWithChildren>

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

// Build identity, so you can confirm which bundle the browser actually loaded.
// Read `window.__BUILD__` in the console, or grep the JS bundle for BUILD_STAMP.
declare const __BUILD_STAMP__: string
declare const __BUILD_ENV__: string
;(window as any).__BUILD__ = { env: __BUILD_ENV__, stamp: __BUILD_STAMP__ }
// eslint-disable-next-line no-console
console.log(`[WashXpress] build ${__BUILD_ENV__} ${__BUILD_STAMP__}`)

const queryClient = new QueryClient()

createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <RecoilRootWithChildren>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RecoilRootWithChildren>
  </QueryClientProvider>,
  // </React.StrictMode>,
)
